import { Longhand } from "../longhand.js";
import Base from "./top.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/bottom}
 * @internal
 */
export default Longhand.extend(Base);
//# sourceMappingURL=bottom.js.map